import { Modal, Row, Col, Input, Segmented } from "antd";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { api } from "../../utils/apiClient";
import { getLangValue } from "../../utils/tools";
import { toast } from "react-toastify";
import ContentLoader from "../../utils/ContentLoader";

const ChurchModal = ({ open, onClose, data, onStatusChange }) => {
      const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];

      const [loading, setLoading] = useState(false);

      const [latitude, setLatitude] = useState("");
      const [longitude, setLongitude] = useState("");
      const [link, setLink] = useState("");
      // const [name, setName] = useState("");
      const [name, setName] = useState({
            ta: "",
            en: "",
      });

      const [selectedLang, setSelectedLang] = useState("ta");

      // Pre-fill values when data changes
      useEffect(() => {
            if (data) {
                  // setName(getLangValue(data?.name));
                  const churchName = {
                        tn: data?.name?.tn || "",
                        en: data?.name?.en || "",
                  };

                  setName(churchName);

                  // Auto-select language
                  if (!churchName.tn && churchName.en) {
                        setSelectedLang("en");
                  } else {
                        setSelectedLang("tn");
                  }
                  setLatitude(data.latitude || "");
                  setLongitude(data.longitude || "");
                  setLink(data.link || "");
            }
      }, [data]);
      // console.log("name===", name)


      if (!data) return null;

      const Item = ({ label, value }) => (
            <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                        {label}
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 500, wordBreak: "break-word" }}>
                        {value || "-"}
                  </div>
            </div>
      );

      // console.log("data=>> ", data);

      if (loading) return <ContentLoader />;

      return (
            <Modal
                  title="Church Details"
                  open={open}
                  onCancel={onClose}
                  onOk={async () => {
                        try {
                              setLoading(true);
                              const res = await api.put(`/church/${data.id}/location`, {
                                    name,
                                    latitude,
                                    longitude,
                                    link,
                              });

                              // console.log("API res==>:",);
                              toast.success(res.data.message || "Church updated successfully")

                              onClose();

                              if (onStatusChange) {
                                    onStatusChange();
                              }

                        } catch (error) {
                              console.error("Update failed:", error);
                        } finally {
                              setLoading(false);
                        }
                  }}
                  width={700}
                  centered
            >
                  <Row gutter={[16, 10]}>
                        <Col xs={24} sm={12}>
                              <div style={{ marginBottom: 16 }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6, }} >
                                          <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                                                Church Name
                                          </div>
                                          <Segmented
                                                className="language-toggle"
                                                size="small"
                                                value={selectedLang}
                                                onChange={setSelectedLang}
                                                options={[
                                                      { label: "Tamil", value: "tn" },
                                                      { label: "English", value: "en" },
                                                ]}
                                          />
                                    </div>
                                    <Input
                                          placeholder={`Enter church name (${selectedLang === "tn" ? "Tamil" : "English"})`}
                                          value={name[selectedLang]}
                                          onChange={(e) =>
                                                setName((prev) => ({
                                                      ...prev,
                                                      [selectedLang]: e.target.value,
                                                }))
                                          }
                                    />
                              </div>
                        </Col>

                        <Col xs={24} sm={12}>
                              <Item label="Place" value={getLangValue(data?.place)} />
                        </Col>

                        <Col xs={24} sm={12}>
                              <div style={{ marginBottom: 16 }}>
                                    <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                                          Latitude
                                    </div>
                                    <Input
                                          placeholder="Enter latitude"
                                          value={latitude}
                                          onChange={(e) => setLatitude(e.target.value)}
                                    />
                              </div>
                        </Col>

                        <Col xs={24} sm={12}>
                              <div style={{ marginBottom: 16 }}>
                                    <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                                          Longitude
                                    </div>
                                    <Input
                                          placeholder="Enter longitude"
                                          value={longitude}
                                          onChange={(e) => setLongitude(e.target.value)}
                                    />
                              </div>
                        </Col>

                        <Col xs={24}>
                              <div style={{ marginBottom: 16 }}>
                                    <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                                          Link
                                    </div>
                                    <Input
                                          placeholder="Enter link (Google Maps / Website)"
                                          value={link}
                                          onChange={(e) => setLink(e.target.value)}
                                    />
                              </div>
                        </Col>
                  </Row>
            </Modal>
      );
};

export default ChurchModal;